<script lang="ts">
    import BaseSkeleton from "@components/skeletons/BaseSkeleton.svelte";
    import ImageSkeleton from "@components/skeletons/ImageSkeleton.svelte";

    import ReviewsItemFrame from "./ReviewsItemFrame.svelte";

    const randomHeight = `${Math.round(Math.random() * (160 - 50)) + 50}px`;
</script>

<ReviewsItemFrame isFeatured={true}>
    <svelte:fragment slot="media">
        <ImageSkeleton ratio={1 / 1} />
    </svelte:fragment>

    <svelte:fragment slot="rating">
        <BaseSkeleton width="50%" height="20px" />
    </svelte:fragment>

    <svelte:fragment slot="title">
        <BaseSkeleton width="100%" height="18px" />
    </svelte:fragment>

    <svelte:fragment slot="text">
        <BaseSkeleton width="100%" height={randomHeight} />
    </svelte:fragment>

    <svelte:fragment slot="product-image">
        <ImageSkeleton ratio={1 / 1} class="gw-crv-skeleton-product-image" />
    </svelte:fragment>

    <svelte:fragment slot="product-title">
        <BaseSkeleton width="100%" height="16px" />
    </svelte:fragment>

    <svelte:fragment slot="product-price">
        <BaseSkeleton width="70%" height="14px" />
    </svelte:fragment>

    <svelte:fragment slot="product-wishlist-btn">
        <BaseSkeleton width="24px" height="24px" />
    </svelte:fragment>
</ReviewsItemFrame>

<style lang="postcss">
    :global(.gw-crv-skeleton-product-image) {
        border-radius: 50%;
    }
</style>
